__turbopack_context__.v({
  "complete": "PdfDownloadPopup-module-scss-module__zAjwSq__complete",
  "complete_button": "PdfDownloadPopup-module-scss-module__zAjwSq__complete_button",
  "complete_content": "PdfDownloadPopup-module-scss-module__zAjwSq__complete_content",
  "complete_desc": "PdfDownloadPopup-module-scss-module__zAjwSq__complete_desc",
  "complete_icon": "PdfDownloadPopup-module-scss-module__zAjwSq__complete_icon",
  "complete_icon_enter": "PdfDownloadPopup-module-scss-module__zAjwSq__complete_icon_enter",
  "complete_note": "PdfDownloadPopup-module-scss-module__zAjwSq__complete_note",
  "complete_text": "PdfDownloadPopup-module-scss-module__zAjwSq__complete_text",
  "complete_title": "PdfDownloadPopup-module-scss-module__zAjwSq__complete_title",
  "form_area": "PdfDownloadPopup-module-scss-module__zAjwSq__form_area",
  "header_title": "PdfDownloadPopup-module-scss-module__zAjwSq__header_title",
  "popup": "PdfDownloadPopup-module-scss-module__zAjwSq__popup",
  "purpose_group": "PdfDownloadPopup-module-scss-module__zAjwSq__purpose_group",
});
